import NavButtons from "@/components/pages/Community/NavButtons/NavButtons";

export default NavButtons;
